export const AURA_CHART_PALETTE = [
    '#48DDC3',
    '#242B59',
    '#F2B84B',
    '#EB6A6A',
    '#8DA2B5',
    '#7C83FD',
] as const;

export const getAuraChartColor = (index: number): string =>
    AURA_CHART_PALETTE[index % AURA_CHART_PALETTE.length];
